// extracted by mini-css-extract-plugin
module.exports = {"header":"Welcome_header__3LgXM","title":"Welcome_title__3Fo9n","footer":"Welcome_footer__3ZK71","schedule":"Welcome_schedule__1GBq_","start":"Welcome_start__v8HuL"};